import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, Icon, Link } from '@Sage/hoi-poi-ui';
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'ActionLink');
const ActionLink = _ref => {
  let {
    icon: iconName = 'add',
    text,
    onClick,
    className
  } = _ref;
  const classes = useStyles();
  const linkProps = useMemo(() => ({
    className: classNames(classes.root, className),
    onClick
  }), [className, classes.root, onClick]);
  return /*#__PURE__*/React.createElement(Link, linkProps, /*#__PURE__*/React.createElement("span", null, text), /*#__PURE__*/React.createElement(Icon, {
    name: iconName
  }));
};
export default /*#__PURE__*/memo(ActionLink);